import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Result } from 'antd';

class AccessError extends Component {
    render() {
        return (
            <Result
                status="403"
                title="403"
                subTitle="Üzgünüz bu sayfayı görmeye yetkiniz bulunmamaktadır."
                extra={<Link to="/"><Button type="primary">Geri</Button></Link>}
            />
        );
    }
}

export default AccessError;


// WEBPACK FOOTER //
// ./src/common/AccessError.js